import { FC, useCallback } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDialogState } from "@/hooks/use-dialog-state";

type Props = {
  onDelete: () => void;
};

export const DeleteCMSTabDialog: FC<Props> = ({ onDelete }) => {
  const { dialog, closeDialog } = useDialogState();

  const handleDelete = useCallback(() => {
    onDelete();
    closeDialog();
  }, [onDelete, closeDialog]);

  return (
    <AlertDialog open={dialog?.name === "delete-cms-tab"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Tab</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this tab?{" "}
            <i className="text-black">
              This action is irreversible and the tab's contents cannot be
              recovered.
            </i>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={closeDialog}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDelete}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
